import { angularJsApp } from "../app";
import { AppServicesEnum } from "../app.model";

export class SharedProperties {
  private isDev: boolean = false;
  private urlInt: string = 'https://integracio.mapaescolar.intranet.gencat.cat';
  private urlPre: string = 'https://preproduccio.mapaescolar.gencat.cat';
  private urlPro: string = 'https://mapaescolar.gencat.cat';
  private url: string = this.urlInt;
  private lastUsedFilter: string = '';
  private selectedCurs: string = '';
  private numResults: number = 0;

  constructor(private $rootScope) { }

  openLoader() {
    this.$rootScope.$broadcast('showOverlayLoader')
  };

  closeLoader() {
    this.$rootScope.$broadcast('hideOverlayLoader');
  };

  getLastFilter(): string {
    return this.lastUsedFilter;
  }

  setLastFilter(value: string): void {
    this.lastUsedFilter = value;
  }

  getSelectedCurs(): string {
    return this.selectedCurs;
  }

  setSelectedCurs(value: string): void {
    this.selectedCurs = value;
  }

  getNumResults(): number {
    return this.numResults;
  }

  setNumResults(value: number): void {
    this.numResults = value;
  }

  baseUrlService(): string {
    return this.isDev ? this.url : '';
  }
}

angularJsApp.service(AppServicesEnum.SHARED_PROPERTIES_SERVICE, SharedProperties);
